export const certificatedata = [
    {
        id:1,
        title: "Cerficate for Web design course",
        about:"Completed 24 hours of online self-study, 48 hours of outside class work and 16 houts In class instruction and 72 houts of project work.",
        image : "../Assets/certificate1.jpg"
    },
    {
        id:2,
        title: "Scalar React Masterclass",
        about:"Attended extensive 2 hours long masterclass based on reactJS and javascript ES6 features along with hands on project.",
        image : "../Assets/React masterclass.png"
    },
    {
        id:3,
        title: "Hackerank ReactJS certification",
        about:"A 1.5 hours long extensive project based certification test.",
        image : "../Assets/hackerank.png"
    }
]